// import { tokenMiddleware } from 'middleware/tokenMiddleware';
import { configureStore } from "@reduxjs/toolkit";
import { applyMiddleware, compose, Action } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createLogger } from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunkMiddleware, { ThunkAction } from "redux-thunk";

import rootReducer from "../reducers/rootReducer";

const loggerMiddleware = createLogger();

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["app", "auth"], //persist Reducers
};
const enhancers = compose(
  applyMiddleware(thunkMiddleware, loggerMiddleware /*tokenMiddleware*/)
);

const devToolsMiddleware = composeWithDevTools(enhancers);

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  // enhancers: [devToolsMiddleware],
});
const persistor = persistStore(store);

export { rootReducer, store, persistor };

export type Store = typeof store;

export type Reducer = typeof rootReducer;

export type AppDispatch = typeof store.dispatch;

// eslint-disable-next-line no-undef
export type State = ReturnType<typeof rootReducer>;

export type AppThunk = ThunkAction<void, State, unknown, Action>;

export default store;
